import { BaseKb3dModel, NodeReference } from '../decorators';
import { IMeshNode } from '../kb3d-models';
import { MaterialNode } from '../materials/material-node';
import { Token } from '../token';
import { SpaceNode } from './space-node';

@BaseKb3dModel({
    token: Token.MeshNode,
})
export abstract class MeshNode extends SpaceNode implements IMeshNode {
    constructor() {
        super();
    }

    /**
     * Dynamically created id that is used to track assets in the 3d engine.  Ensures there is
     * no duplicate id's when there are nested scenes.
     */
    public _activeDynamicId?: string;
    public _polygonCount?: number = 0;
    public _verticesCount?: number = 0;

    public flipSurfaceOrientation?: boolean;
    public receiveShadows?: boolean;
    public castShadows?: boolean;
    public checkCollisions?: boolean;
    public isPickable?: boolean;

    @NodeReference(MaterialNode, '' as any)
    public materialId?: string = null as any;

    public opacity?: number;

    public getSpaceChildren() {
        return new Array<SpaceNode>();
    }

    copyPropertiesTo(target: SpaceNode) {
        super.copyPropertiesTo(target);
        if (target instanceof MeshNode) {
            target.flipSurfaceOrientation = this.flipSurfaceOrientation;
            target.receiveShadows = this.receiveShadows;
            target.castShadows = this.castShadows;
            target.checkCollisions = this.checkCollisions;
            target.materialId = this.materialId;
            target.opacity = this.opacity;
        }
    }
}
